import React from 'react';
import { BdsIcon, BdsTooltip } from '@/core/constants/webComponents';
import type { TooltipPostionType } from 'blip-ds/dist/types/components/tooltip/tooltip';

export interface PlatformIconLinkProps {
  publicationUrl: string;
  tooltipText: string;
  channelIconUrl?: string;
  platform: string;
  onNavigate?: () => void;
  wrapperClassName?: string;
  linkClassName?: string;
  buttonClassName?: string;
  tooltipPosition?: TooltipPostionType;
}

export const PlatformIconLink: React.FC<PlatformIconLinkProps> = ({
  publicationUrl,
  tooltipText,
  channelIconUrl,
  platform,
  onNavigate,
  wrapperClassName,
  linkClassName,
  buttonClassName,
  tooltipPosition = 'top-center',
}) => {
  const iconContent = channelIconUrl ? (
    <img src={channelIconUrl} alt={platform} width={24} height={24} />
  ) : (
    <BdsIcon theme="outline" type="logo" name={platform} size="large" />
  );

  if (publicationUrl) {
    return (
      <div className={wrapperClassName}>
        <BdsTooltip position={tooltipPosition} tooltip-text={tooltipText}>
          <a
            href={publicationUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
            aria-label={tooltipText}
            onClick={onNavigate}
          >
            {iconContent}
          </a>
        </BdsTooltip>
      </div>
    );
  }

  return (
    <div className={wrapperClassName}>
      <button
        type="button"
        className={buttonClassName}
        tabIndex={-1}
        aria-hidden="true"
      >
        {iconContent}
      </button>
    </div>
  );
};
